import { render, staticRenderFns } from "./GoodsPay.vue?vue&type=template&id=71e4cfca&scoped=true&"
import script from "./GoodsPay.vue?vue&type=script&lang=js&"
export * from "./GoodsPay.vue?vue&type=script&lang=js&"
import style0 from "./GoodsPay.vue?vue&type=style&index=0&id=71e4cfca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e4cfca",
  null
  
)

export default component.exports